import React, { useEffect, useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faMagnifyingGlass, faXmark } from '@fortawesome/free-solid-svg-icons'
import PrimaryButton from '../Button/PrimaryButton'
import { FieldLabel, inputClass } from '../Input/TextInput'
import { EMPTY_SEARCH, MIN_SEARCH_LENGTH, hasSearch } from '../../utils/search'

export const SEARCH_FIELDS = [
  {
    name: 'fullname',
    label: 'Nama Lengkap',
    chip: 'Nama',
    placeholder: 'mis: budi santoso',
  },
  {
    name: 'nik',
    label: 'Nomor Identitas (NIK)',
    chip: 'NIK',
    placeholder: 'mis: 3201010101',
    inputMode: 'numeric',
  },
  {
    name: 'email',
    label: 'E-mail',
    chip: 'E-mail',
    placeholder: 'mis: gmail.com',
  },
]

const isTooShort = (value) => {
  const trimmed = String(value ?? '').trim()
  return trimmed.length > 0 && trimmed.length < MIN_SEARCH_LENGTH
}

const SearchPendaftarModal = ({ open, value, onClose, onSubmit }) => {
  const [draft, setDraft] = useState(value ?? EMPTY_SEARCH)
  const [errors, setErrors] = useState({})

  // Tiap dibuka, isian disamakan dengan filter yang sedang aktif -- supaya
  // membuka ulang memperlihatkan apa yang sedang dicari, bukan form kosong.
  useEffect(() => {
    if (open) {
      setDraft(value ?? EMPTY_SEARCH)
      setErrors({})
    }
  }, [open, value])

  const onFieldChange = (name, fieldValue) => {
    setDraft((current) => ({ ...current, [name]: fieldValue }))
    setErrors((current) => ({ ...current, [name]: undefined }))
  }

  // Satu huruf terlalu mahal untuk dicocokkan di 52 ribu baris dan hasilnya
  // hampir semua baris. Ditolak di sini, bukan dibuang diam-diam.
  const submit = (event) => {
    event.preventDefault()
    const nextErrors = {}
    SEARCH_FIELDS.forEach((field) => {
      if (isTooShort(draft[field.name])) {
        nextErrors[field.name] = `Minimal ${MIN_SEARCH_LENGTH} huruf`
      }
    })
    if (Object.keys(nextErrors).length > 0) {
      setErrors(nextErrors)
      return
    }
    onSubmit(draft)
  }

  return (
    <div className={`modal ${open ? 'modal-open' : ''}`}>
      <div className="modal-box relative max-w-lg p-0 rounded-card overflow-hidden">
        <form onSubmit={submit}>
          <div className="flex items-start justify-between gap-4 px-5 py-4 border-b border-line">
            <div>
              <h3 className="font-bold text-base text-ink">Cari Pendaftar</h3>
              <p className="text-[13px] text-muted">
                Isi kolom yang perlu saja. Kolom yang diisi digabung dengan DAN.
              </p>
            </div>
            <button
              type="button"
              aria-label="Tutup"
              className="w-8 h-8 flex-none rounded-lg border border-line text-muted hover:bg-subtle hover:text-ink transition-colors"
              onClick={onClose}
            >
              <FontAwesomeIcon icon={faXmark} />
            </button>
          </div>

          <div className="px-5 py-5 flex flex-col gap-4">
            {SEARCH_FIELDS.map((field) => (
              <div key={field.name}>
                <FieldLabel label={field.label} />
                <input
                  type="text"
                  className={inputClass}
                  value={draft[field.name] ?? ''}
                  inputMode={field.inputMode}
                  placeholder={field.placeholder}
                  onChange={(e) => onFieldChange(field.name, e.target.value)}
                />
                {errors[field.name] && (
                  <p className="mt-1.5 text-[12px] text-[#E5484D]">
                    {errors[field.name]}
                  </p>
                )}
              </div>
            ))}
            <p className="text-[12px] text-muted">
              Pencocokan sebagian, tanpa peduli huruf besar-kecil.
            </p>
          </div>

          <div className="flex items-center justify-between gap-2 px-5 py-4 border-t border-line bg-subtle">
            {hasSearch(draft) ? (
              <button
                type="button"
                className="text-[13px] font-medium text-muted hover:text-ink transition-colors"
                onClick={() => {
                  setDraft(EMPTY_SEARCH)
                  setErrors({})
                }}
              >
                Kosongkan
              </button>
            ) : (
              <span />
            )}
            <div className="flex items-center gap-2">
              <button
                type="button"
                className="h-10 px-4 rounded-xl border border-line bg-white text-sm font-semibold text-ink hover:bg-subtle transition-colors"
                onClick={onClose}
              >
                Batal
              </button>
              <PrimaryButton type="submit">
                <FontAwesomeIcon icon={faMagnifyingGlass} />
                Cari
              </PrimaryButton>
            </div>
          </div>
        </form>
      </div>
    </div>
  )
}

export default SearchPendaftarModal
